export default __webpack_public_path__ + "static/media/neftrtgs-icon.89a29820.svg";